module.exports = __webpack_public_path__ + "img/p52.66426405.jpg";